import React from 'react';
import {Route, Switch} from 'react-router-dom';

import NetworksList from 'routes/app/components/Management/NetworkList';

class Phone extends React.Component {

  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.path}`} render={() => <NetworksList type="phone_sms"/>}/>
      </Switch>
    )
  }
}

module.exports = Phone;



// WEBPACK FOOTER //
// ./routes/app/routes/management/phone/index.js